import axiosInstance from './axiosInstance';

const getIndexers = () => axiosInstance.get('/internal/admin/balances');

export default getIndexers;
